/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ScenarioRecordingMessageType {
    ClinicalVignette = 0,
    ScenarioDescription = 1,
    ScenarioCaseSummary = 2,
    FreeText = 3,
    NotSet = 4,
}
